import React from 'react';
import { useNavigate } from 'react-router-dom';
import products from '../../data/products';
import ProductCard from './ProductCard';
import './Home.css';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home">
      <section className="home__hero">
        <h1>Pure. Natural. Handcrafted.</h1>
        <p>Soaps made with love, botanicals, and zero compromise.</p>
      </section>

      <section className="home__grid-section">
        <h2 className="home__section-title">Our Soaps</h2>
        <div className="home__grid">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onClick={() => navigate(`/product/${product.id}`)}
            />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;